
































































































































































































































































































































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

import PageMain from '@part/layout/PageMain.vue';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            checkboxModel: ["item1"],
            radioModel: null,
            selectOptions: [ [ 'key1', 'value1' ], [ 'key2', 'value2' ], [ 'key3', 'value3' ] ],
            selectModel: 'item1',
            selectModelMulti: ['item1'],
            tabsModel: 1,
            textareaModel: '',
            textModel: '',
            telModel: '',
            emailModel: '',
            urlModel: '',
            numberModel: '',
            timeModel: '',
            dateModel: '',
            datetimeLocalModel: '',
            weekModel: '',
            monthModel: '',
            passwordModel: '',
            fileModel: '',
        };
    },

    components: {
        PageMain
    },

    methods: {
        buttonClicked(e) {
        },

        showPopup() {
            this.$root.$emit('popup::show::default', {
                component: () => import('@part/features/Popup.vue'),
                componentContent: () => import('@part/popups/organisation.vue'),
            })
        },

        showPopup2() {
            this.$root.$emit('popup::show::default', {
                component: () => import('@part/features/Popup.vue'),
                componentContent: () => import('@part/popups/projects.vue'),
            })
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Dev extends Vue {}

